<template>
  <div class="lesson__box">
    <table class="Tutor-list">
      <thead>
        <tr>
          <th>Date</th>
          <th>Period</th>
          <th>Type</th>
          <th>University</th>
          <th>Campus</th>
          <th>Booth</th>
          <th>Course</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="schedule of lessonSchedules"
          :key="schedule.lessonId"
        >
          <td>{{ schedule.date.format('YYYY/MM/DD (ddd)') }}</td>
          <td>{{ schedule.period }}</td>
          <td>{{ schedule.type | type }}</td>
          <td>{{ schedule.university.name }}</td>
          <td>{{ schedule.campus && schedule.campus.name }}</td>
          <td>{{ schedule.booth | booth }}</td>
          <td>{{ schedule.course && schedule.course.name }}</td>
        </tr>
      </tbody>
    </table>
      <div v-show="lessonSchedules.length === 0" class="no-data">No Data Available</div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { LessonSchedule } from '@/store/mypage/types'
import { RootState } from '@/store/types'
import { Booth } from '@/store/booths/types'
import { scheduleType, ScheduleTypes } from '@/store/schedules/types'

@Component({
  filters: {
    booth(b: Booth|null): string {
      if (!b) return '-'
      return `${b.building}-${b.room}-${b.number}`
    },
    type: (t: scheduleType): string => ScheduleTypes[t],
  },
})
export default class TutorLessonSchedules extends Vue {
  private get lessonSchedules(): LessonSchedule[] {
    return (this.$store.state as RootState).mypage.lessonSchedules
  }
}
</script>

<style scoped>
  table.Tutor-list {
    width:100%;
    border-collapse:collapse;
    background: #fff;
    margin-bottom:0px;
  }

  table.Tutor-list thead tr {
    border: 2px solid #DBDBDB
  }

  table.Tutor-list thead th, table.Tutor-list thead td {
    padding: 20px;
    text-align: left;
  }

  table.Tutor-list tbody tr:nth-child(odd) {
    background: #D8D8D8;
  }

  table.Tutor-list th {
    padding:10px;
  }

  table.Tutor-list td {
    padding:20px;
  }

  .detail-button {
    display: block;
    text-decoration: none;
    color: #000;
    padding: 10px;
    border: 2px solid #AAAFB6;
    border-radius: 20px;
    cursor: pointer;
  }

  .detail-button:hover {
    background: #000;
  }

  .lesson__box {
    overflow-y: auto;
    max-height: 490px;
  }

  ::-webkit-scrollbar{
  width: 10px;
}

::-webkit-scrollbar-track{
  background: rgb(238, 238, 238);
  border: none;
  border-radius: 10px;
  box-shadow: inset 0 0 2px rgb(221, 221, 221);
}

::-webkit-scrollbar-thumb{
  background: #ccc;
  border-radius: 10px;
  box-shadow: none;
}

tr {
  border: 2px solid #DBDBDB
}

td {
  padding: 20px;
  text-align: left;
}

tbody tr:nth-child(odd) {
  background: #D8D8D8;
}

.no-data {
    display: flex;
    justify-content: center;
    padding: 20px;
    border: 2px solid #DBDBDB;
    margin-top: 0px;
    background: rgb(221, 220, 220);
  }
</style>
